import React, { forwardRef } from 'react';
import classNames from 'classnames/bind';
import TableForm from '@mpc/common/src/components/TableForm';
import { Button, Tag } from '@bedrock/components';
import CopyIcon from '@mpc/common/src/components/CopyIcon';
import CurrencyType from "@mpc/common/src/components/SForm/SFormElement/CurrencyType";
import style from './index.less';

const cx = classNames.bind(style);

// 预付款信息类型定义
interface PrePayInfoVo {
  expense_control_no?: string;
  payment_status_desc?: string;
  amount?: number;
  payment_initiator_name?: string;
  payment_initiator_email?: string;
  expense_control_created_time?: string;
  payment_time?: string;
  payment_record?: string;
}

type Props = {
  data?: PrePayInfoVo[];
};

const OutPrePayInfoTable: React.FC<Props> = forwardRef((props, ref) => {
  const { data = [] } = props;
  return (
    <div className={cx('tableFormBox')}>
      <TableForm
        scroll={{ x: 'max-content', y: 500 }}
        value={data?.filter(item => item) || []}
        emptyText="暂无数据"
        formProps={{}}
        formColumns={({ add, remove }) => [
          {
            title: <div className={cx('bold')}>MPC预付单号</div>,
            dataIndex: 'prepayment_no',
            width: 120,
            align: 'left',
            render: (text, record, index) => {
              if (!text) return '--';
              return (
                <div className={cx('bold', 'flex items-center')}>
                  <Button
                    type="link"
                    onClick={() => {
                      window.open(`/#/outWorkbenchPortal/outPrepayment/allPrepayment?projectId=${record?.id}`);
                    }}
                  >
                    {text}
                  </Button>
                  <CopyIcon text={text} tipToolTitle="复制" />
                </div>
              );
            },
          },
          {
            title: <div className={cx('bold')}>状态</div>,
            dataIndex: 'status',
            width: 76,
            align: 'left',
            render: (status, record, index) => {
              const statusColorMap = {
                '1':  'blue',
                '2':  'orange',
                '3':  'blue',
                '4':  'blue',
                '5':  'green',
                '6':  'grey',
              };
              return <Tag size="small" text={record?.status_desc} color={`light-${statusColorMap[status]}` as any} />
            },
          },
          {
            title: <div className={cx('bold')}>发票方式</div>,
            dataIndex: 'invoice_method_desc',
            width: 160,
            align: 'left',
            render: (text, record, index) => {
              return text || '--';
            },
          },
          {
            title: <div className={cx('bold')}>预付金额</div>,
            dataIndex: 'prepayment_amount',
            width: 144,
            align: 'right',
            render: (amount, record, index) => {
              if (!amount) return '--';
              return (
                <CurrencyType
                  view
                  showAmountOrder={false}
                  currencyColor="black"
                  value={{
                    value: amount,
                    currency: record.currency,
                  }}
                />
              );
            },
          },
        ]}
      />
    </div>
  );
});

export default OutPrePayInfoTable;
